import { types } from '../constants/dashboardCardTypes';
import {
  isFactInPeriod,
  isFactWithClosedInPeriod,
  isPlanInPeriod,
} from './reportChartFilters';
import moment from 'moment';

function getDaysDiff(startStr, endStr) {
  if (!startStr || !endStr) return 0;

  const start = moment(startStr);
  const end = moment(endStr);

  if (!start.isValid() || !end.isValid()) return 0;

  return end.diff(start, 'days');
}

export const dashboardRequestsProcessor = (
  requests = [],
  createDateRange,
  dashboardType
) => {
  const obj = {
    barData: [],
    count: 0,
    periodInfo: {
      TotalUpTo10DaysPlan: 0,
      TotalUpTo10DaysFact: 0,
      TotalUpTo10DaysClosed: 0,
      TotalFrom10To45DaysPlan: 0,
      TotalFrom10To45DaysFact: 0,
      TotalFrom10To45DaysClosed: 0,
      TotalOver45DaysPlan: 0,
      TotalOver45DaysFact: 0,
      TotalOver45DaysClosed: 0,
    },
    totalFact: 0,
    totalClosed: 0,
    totalPlan: 0,
  };

  const [rawStart, rawEnd] = createDateRange.split(',');
  const periodStart = rawStart ? moment.utc(rawStart) : null;
  const periodEnd = rawEnd ? moment.utc(rawEnd).endOf('day') : null;

  const regionMap = {};

  requests.forEach((item) => {
    const regionName = item.regionName || 'Без района';

    if (!regionMap[regionName]) {
      regionMap[regionName] = {
        regionName,
        requests: [],
      };
    }

    regionMap[regionName].requests.push(item);
  });

  if (dashboardType === types.complete) {
    Object.values(regionMap).forEach((item) => {
      const planReq = item.requests.filter((req) =>
        isPlanInPeriod(req, periodStart, periodEnd)
      );

      const factReq = item.requests.filter((req) =>
        isFactInPeriod(req, periodStart, periodEnd)
      );

      const closedReq = item.requests.filter((req) =>
        isFactWithClosedInPeriod(req, periodStart, periodEnd)
      );

      obj.barData.push({
        regionName: item.regionName,
        plan: planReq.length,
        fact: factReq.length,
        closed: closedReq.length,
      });

      obj.totalPlan += planReq.length;
      obj.totalFact += factReq.length;
      obj.totalClosed += closedReq.length;
    });
  } else if (dashboardType === types.period) {
    Object.values(regionMap).forEach((item) => {
      const upTo10Days = item.requests.filter(
        (req) => getDaysDiff(req.createDateTime, req.executeDateTime) < 10
      );

      const from10To45Days = item.requests.filter(
        (req) =>
          getDaysDiff(req.createDateTime, req.executeDateTime) >= 10 &&
          getDaysDiff(req.createDateTime, req.executeDateTime) <= 45
      );

      const over45Days = item.requests.filter(
        (req) => getDaysDiff(req.createDateTime, req.executeDateTime) > 45
      );

      const upTo10DaysPlan = upTo10Days.filter((req) =>
        isPlanInPeriod(req, periodStart, periodEnd)
      );

      const upTo10DaysFact = upTo10Days.filter((req) =>
        isFactInPeriod(req, periodStart, periodEnd)
      );

      const upTo10DaysClosed = upTo10Days.filter((req) =>
        isFactWithClosedInPeriod(req, periodStart, periodEnd)
      );

      const from10To45DaysPlan = from10To45Days.filter((req) =>
        isPlanInPeriod(req, periodStart, periodEnd)
      );

      const from10To45DaysFact = from10To45Days.filter((req) =>
        isFactInPeriod(req, periodStart, periodEnd)
      );

      const from10To45DaysClosed = from10To45Days.filter((req) =>
        isFactWithClosedInPeriod(req, periodStart, periodEnd)
      );

      const over45DaysPlan = over45Days.filter((req) =>
        isPlanInPeriod(req, periodStart, periodEnd)
      );

      const over45DaysFact = over45Days.filter((req) =>
        isFactInPeriod(req, periodStart, periodEnd)
      );

      const over45DaysClosed = over45Days.filter((req) =>
        isFactWithClosedInPeriod(req, periodStart, periodEnd)
      );

      let upTo10DaysPlanCount = [...new Set(upTo10DaysPlan)].length;
      let upTo10DaysFactCount = [...new Set(upTo10DaysFact)].length;
      let upTo10DaysClosedCount = [...new Set(upTo10DaysClosed)].length;
      let from10To45DaysPlanCount = [...new Set(from10To45DaysPlan)].length;
      let from10To45DaysFactCount = [...new Set(from10To45DaysFact)].length;
      let from10To45DaysClosedCount = [...new Set(from10To45DaysClosed)].length;
      let over45DaysPlanCount = [...new Set(over45DaysPlan)].length;
      let over45DaysFactCount = [...new Set(over45DaysFact)].length;
      let over45DaysClosedCount = [...new Set(over45DaysClosed)].length;

      obj.periodInfo.TotalUpTo10DaysPlan += upTo10DaysPlanCount;
      obj.periodInfo.TotalUpTo10DaysFact += upTo10DaysFactCount;
      obj.periodInfo.TotalUpTo10DaysClosed += upTo10DaysClosedCount;
      obj.periodInfo.TotalFrom10To45DaysPlan += from10To45DaysPlanCount;
      obj.periodInfo.TotalFrom10To45DaysFact += from10To45DaysFactCount;
      obj.periodInfo.TotalFrom10To45DaysClosed += from10To45DaysClosedCount;
      obj.periodInfo.TotalOver45DaysPlan += over45DaysPlanCount;
      obj.periodInfo.TotalOver45DaysFact += over45DaysFactCount;
      obj.periodInfo.TotalOver45DaysClosed += over45DaysClosedCount;

      obj.barData.push({
        regionName: item.regionName,
        upTo10DaysPlan: upTo10DaysPlanCount,
        upTo10DaysFact: upTo10DaysFactCount,
        upTo10DaysClosed: upTo10DaysClosedCount,
        from10To45DaysPlan: from10To45DaysPlanCount,
        from10To45DaysFact: from10To45DaysFactCount,
        from10To45DaysClosed: from10To45DaysClosedCount,
        over45DaysPlan: over45DaysPlanCount,
        over45DaysFact: over45DaysFactCount,
        over45DaysClosed: over45DaysClosedCount,
      });
    });
  } else {
    Object.values(regionMap).forEach((item) => {
      obj.barData.push({
        regionName: item.regionName,
        count: item.requests.length,
      });
    });
  }

  return obj;
};
